
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate-now",
      function () {
        return require("private-next-pages/donate-now.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate-now"])
      });
    }
  